<div
  class="button-holder"
  [style.background-color]="color"
  (click)="onClick()"
  bpAddRtlClass
>
  <ion-button fill="clear" color="light" bpAddRtlClass>
    <ion-icon slot="icon-only" name="close"></ion-icon>
  </ion-button>
</div>
